var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { IntersectionType } from "@nestjs/swagger";
import { Type } from "class-transformer";
import { IsDate, IsNumber, IsOptional } from "class-validator";
class PatientsStats {
}
__decorate([
    IsNumber()
], PatientsStats.prototype, "totalAvailablePatients", void 0);
__decorate([
    IsNumber()
], PatientsStats.prototype, "totalIdentifiedPatients", void 0);
__decorate([
    IsNumber()
], PatientsStats.prototype, "totalFullRecordsAccessedPatients", void 0);
__decorate([
    IsNumber()
], PatientsStats.prototype, "totalIdentifiedRecordsAccessedPatients", void 0);
__decorate([
    IsNumber()
], PatientsStats.prototype, "totalAnyRecordsAccessedPatients", void 0);
__decorate([
    IsNumber()
], PatientsStats.prototype, "totalPrescreenConsentedPatients", void 0);
__decorate([
    IsNumber()
], PatientsStats.prototype, "totalReadyToEnrollingPatients", void 0);
__decorate([
    IsNumber()
], PatientsStats.prototype, "totalEnrolledPatients", void 0);
class RecordAccessStats {
}
__decorate([
    IsNumber()
], RecordAccessStats.prototype, "totalFullRecordsAccessed", void 0);
__decorate([
    IsNumber()
], RecordAccessStats.prototype, "totalIdentifiedRecordsAccessed", void 0);
class StudyRecordAccessStats {
}
__decorate([
    IsNumber()
], StudyRecordAccessStats.prototype, "totalStudiesAccessingFullRecords", void 0);
__decorate([
    IsNumber()
], StudyRecordAccessStats.prototype, "totalStudiesAccessingIdentifiedRecords", void 0);
__decorate([
    IsNumber()
], StudyRecordAccessStats.prototype, "totalStudiesAccessingAnyRecords", void 0);
export class Stats extends IntersectionType(PatientsStats, RecordAccessStats, StudyRecordAccessStats) {
}
export class StudyStats extends IntersectionType(PatientsStats, RecordAccessStats) {
}
export class TimelineStats extends RecordAccessStats {
}
__decorate([
    IsNumber()
], TimelineStats.prototype, "totalAvailablePatients", void 0);
__decorate([
    Type(() => Date),
    IsDate()
], TimelineStats.prototype, "endOfWeek", void 0);
export class PatientStats {
}
__decorate([
    IsNumber()
], PatientStats.prototype, "totalStudiesContributedTo", void 0);
__decorate([
    IsNumber()
], PatientStats.prototype, "totalResearchAreasContributedTo", void 0);
__decorate([
    IsNumber()
], PatientStats.prototype, "totalRequestsReceived", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], PatientStats.prototype, "healthSystemTotalPatients", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], PatientStats.prototype, "healthSystemTotalStudiesContributedTo", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], PatientStats.prototype, "healthSystemResearchAreasContributedTo", void 0);
export var StatsInterval;
(function (StatsInterval) {
    StatsInterval["DAILY"] = "DAILY";
    StatsInterval["WEEKLY"] = "WEEKLY";
})(StatsInterval || (StatsInterval = {}));
export class HealthSystemStats {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsNumber()
], HealthSystemStats.prototype, "totalAvailablePatients", void 0);
__decorate([
    IsNumber()
], HealthSystemStats.prototype, "totalPatientsCompletedOnboarding", void 0);
__decorate([
    IsNumber()
], HealthSystemStats.prototype, "totalPatientsOptedOutOfHealthEx", void 0);
__decorate([
    IsNumber()
], HealthSystemStats.prototype, "totalEnrollmentConsentedPatients", void 0);
__decorate([
    IsNumber()
], HealthSystemStats.prototype, "totalPrescreenConsentedPatients", void 0);
__decorate([
    IsNumber()
], HealthSystemStats.prototype, "totalRequestedEnrollmentConsentedPatients", void 0);
__decorate([
    IsNumber()
], HealthSystemStats.prototype, "totalRequestedPrescreenConsentedPatients", void 0);
__decorate([
    IsNumber()
], HealthSystemStats.prototype, "totalIdentifiedPatients", void 0);
__decorate([
    IsNumber()
], HealthSystemStats.prototype, "totalIdentifiedRecordsAccessed", void 0);
__decorate([
    IsNumber()
], HealthSystemStats.prototype, "totalResearchStudies", void 0);
__decorate([
    IsNumber()
], HealthSystemStats.prototype, "totalConditionsAndDiseases", void 0);
export class HealthSystemStatsDto extends HealthSystemStats {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => Date),
    IsDate()
], HealthSystemStatsDto.prototype, "date", void 0);
